import React from 'react';
import { Link } from "react-router-dom";

// import components
import NavItem from './NavItem';
import RouterNavItem from "./RouterNavItem";

// import styled components
import { Grid } from '../../styled';
import { NavContainer } from './styled';

const Nav = () => (
  <NavContainer role="navigation">
    <Grid>
      <ul>
        <RouterNavItem target="team" label="Meet the Team" />
        <RouterNavItem to="/draw-request" label="Submit Draw Request" />
        <RouterNavItem target="getintouch" label="Get in Touch" />
        <RouterNavItem target="loanprograms" label="Loan Programs" />
        <RouterNavItem target="constroadmap" label="Construction Road Map" />
      </ul>
    </Grid>
  </NavContainer>
);

export default Nav;
